import { useEffect, useState } from "react"
import { reportError, toastMessage } from "@/(front-desk)/utils/functions"
import { useForm } from "react-hook-form"
import { LoadingIcon } from "@/(front-desk)/utils/patterns"
import TypeSelect from "@/(front-desk)/user/compete/(components)/CertificateApply/TypeSelect"
import Info from "@/(front-desk)/user/compete/(components)/CertificateApply/Info"
import Confirm from "@/(front-desk)/user/compete/(components)/CertificateApply/Confirm"
import Update from "@/(front-desk)/user/compete/(components)/CertificateApply/Update"
import Success from "@/(front-desk)/user/compete/(components)/CertificateApply/Success"
import Error from "@/(front-desk)/user/compete/(components)/CertificateApply/Error"
import Popup from "@/(front-desk)/components/Popup"
import classNames from "classnames"
import lscache from "lscache"
import axios from "axios"
import dayjs from "dayjs"
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-tw'

dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.locale('zh-tw')

export default function CertificateApply({id, setPopup}) {

    const [ step, setStep ] = useState(null) // null, info, confirm, update, success, error
    const [ data, setData ] = useState(null)
    const [ errorMsg, setErrorMsg ] = useState(null)
    const {
        formState: { errors, isValid },
        reset,
        watch,
        control,
        setError,
        handleSubmit,
    } = useForm()

    useEffect(() => {
        getCertificateData()
    }, [])

    useEffect(() => {
        if (data) {
            // console.log('data: ', data)
            const applyData = data.last_application || data.default

            reset({
                certificate_type: null,
                applicant_names: applyData.applicant_names?.filter((e) => e),
                applicant_names_en: applyData.applicant_names_en?.filter((e) => e),
                advisor_names: applyData.advisor_names?.filter((e) => e),
                units: applyData.units?.filter((e) => e),
                award_entry_id: applyData.award_entry_id?.filter((e) => e),
            })
        }
    }, [data])

    function getCertificateData() {
        axios.get(`/api/v1/competition/certificate/${id}`, {
			headers: {
				Authorization: `Bearer ${lscache.get('access')}`
			}
        })
        .then((res) => {
            // console.log(res.config.url, res.data.body)
            setData(res.data.body)
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            reportError(err)
            toastMessage('error', '系統出了點問題，請稍候再試一次！')
            setPopup(null)
        })
    }

    function send(data) {
        // console.log('data: ', data)
        const { shortcut } = data.certificate_type
        const postData = {
            certificate_type: shortcut,
            applicant_names: data.applicant_names,
            applicant_names_en: data.applicant_names_en,
            advisor_names: data.advisor_names?.length === 0 ? ['無'] : data.advisor_names,
            units: data.units,
        }
        if (shortcut.includes('nominee') || shortcut === 'award') {
            postData.award_entry_id = data.certificate_type.id
        }
        // if (shortcut === 'award') {
        //     postData.applicant_names_en = data.applicant_names_en
        // }
        // console.log('postData: ', postData)
        axios.post(`/api/v1/competition/certificate/${id}/apply`, postData, {
            headers: {
                Authorization: `Bearer ${lscache.get('access')}`
            }
        })
        .then((res) => {
            // console.log(res.config.url, res.data.body)
            setStep('success')
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            const create_time_err = err.response?.data?.detail?.create_time
            
            if (create_time_err) {
                const duration = dayjs.duration(err.response?.data?.detail?.timegap, 'seconds').humanize()
                const type = `${data.certificate_type?.label}${data.certificate_type?.shortcut === 'award' ? ' 獲獎證明' : ''}`
                setErrorMsg(`您已提交過${type}的申請，需間隔 ${duration}後再重新申請。`)
            }
            else {
                setErrorMsg('系統出了點問題，請稍候再試一次！')
                reportError(err)
            }

            setStep('error')
        })
    }


    if (!data) return (
        <Popup contentClassName="!bg-[transparent] flex-center">
            <LoadingIcon />
        </Popup>
    )
    else return (
        <Popup contentClassName="!max-w-[30rem] text-black-900" onClose={() => setPopup(null)}>
            <form>
                <div className={classNames('w-full', {'hidden': step !== null})}>
                    <TypeSelect
                        project={data.default.project}
                        pending_applications={data.pending_applications}
                        control={control}
                        setStep={setStep}
                        setPopup={setPopup}
                    />
                </div>
                <div className={classNames('w-full', {'hidden': step !== 'info'})}>
                    <Info
                        certificate_type={watch('certificate_type')}
                        project={data.default.project}
                        setStep={setStep}
                        isValid={isValid}
                    />
                </div>
                <div className={classNames('w-full', {'hidden': step !== 'confirm'})}>
                    <Confirm
                        data={watch()}
                        project={data.default.project}
                        certificate_type={watch('certificate_type')}
                        step={step}
                        setStep={setStep}
                        submit={handleSubmit(send)}
                    />

                </div>
                <div className={classNames('w-full', {'hidden': step !== 'update'})}>
                    <Update
                        control={control}
                        project={data.default.project}
                        certificate_type={watch('certificate_type')}
                        setStep={setStep}
                        isValid={isValid}
                    />
                </div>
                <div className={classNames('w-full', {'hidden': step !== 'success'})}>
                    <Success
                        certificate_type={watch('certificate_type')}
                        setPopup={setPopup}
                    />
                </div>
                <div className={classNames('w-full', {'hidden': step !== 'error'})}>
                    <Error
                        certificate_type={watch('certificate_type')}
                        errorMsg={errorMsg}
                        setPopup={setPopup}
                    />
                </div>
            </form>
        </Popup>
    )
}